import React from 'react';
import { IconProps } from '.';

const SvgBoxMove = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M3.5 3.5H9V11h6V3.5h5.5V11H22V2H2v20h9v-1.5H3.5v-17Zm7 6v-6h3v6h-3Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='m18 12.152 2.508 2.507-.849.849-1.059-1.06V17.4h2.951l-1.059-1.06.849-.848L23.849 18l-2.508 2.508-.849-.849 1.06-1.06H18.6v2.952l1.06-1.059.848.849L18 23.849l-2.508-2.508.849-.849 1.059 1.06V18.6h-2.951l1.059 1.059-.849.849L12.151 18l2.508-2.508.849.849-1.06 1.059H17.4v-2.951l-1.06 1.059-.848-.849L18 12.151Z'
      />
    </svg>
  );
};

export default SvgBoxMove;
